export function Controls() {
  const keyStates = {}

  const onKeyDown = (e) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return
    keyStates[e.code] = true
  }

  const onKeyUp = (e) => {
    if (e.metaKey || e.ctrlKey || e.altKey) return
    keyStates[e.code] = false
  }

  window.addEventListener("keydown", onKeyDown)
  window.addEventListener("keyup", onKeyUp)

  return {
    isKeyDown: (key) => {
      return keyStates[key]
    },
    cleanup: () => {
      window.removeEventListener("keydown", onKeyDown)
      window.removeEventListener("keyup", onKeyUp)
    },
  }
}
